import React, {Component} from "react";
import {connect} from "react-redux";
import {Button} from 'antd';
import {Route, Switch} from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import {
  clearProps,
  createResource,
  fetchResource,
  fetchTpwNo,
  getResource,
  getResourceForDownload,
  saveResourceQuery,
  setValueForTotalLabour,
  setValueForTotalSpare,
} from "../../appRedux/actions/ThirdPartyWorkQuotation";
import {fetchFilter, fetchSubDocumentFilter,} from '../../appRedux/actions';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import * as _ from 'lodash';

export class ThirdPartyWorkQuotation extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: []
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    this.fetchList();
    this.props.fetchFilter(this.props.resourceName);
    this.props.fetchSubDocumentFilter('Document');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) =>
        Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({visibleColumns: columns}, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
  }

  handleColumnChange = (value, array) => {
    const {filters} = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = {...this.props.query};
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = {...this.props.query};
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = {...this.props.query};
    query.pagination = {...query.pagination, current: pagination.current};
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const { resourceName } = this.props;
    Object.keys(filters).forEach((item) => {

      if (item === '_id') {
        return ;
      }

      if (selectedColumns.indexOf(item) === -1) {
        return;
      }
      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
      })
    });

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record) => (
        <div>
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button type="primary" size='small' onClick={() => this.edit(record._id)}>View Quote</Button>
          }}/>
        </div>
      ),
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  storeTotalData = (data, field, ind, index = null) => {
    if(field === 'spareRequired') {
     this.props.setValueForTotalSpare({data: data, index: ind, removeIndex: index});
    }
    if(field === 'labourRequired') {
      this.props.setValueForTotalLabour({data: data, index: ind, removeIndex: index});
    }
  };

  fetchTpwNo = (tpwSearchQuery) => {
      const data = {
        tpwSearchQuery: tpwSearchQuery,
      };
      this.props.fetchTpwNo(data);
  }

  fetchList = () => {
    this.props.getResource();
  };

  createResource = (values) => {
    this.props.createResource(values);
  };

  create = () => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = (id) => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "ThirdPartyWorkQuotation");
  }

  render() {
    const {match, data, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName} = this.props;
    const {columns, visibleColumns} = this.state;
    faviconDynamicFunction(authUser);

    return (<div>
      <h2>{sanitizeFieldName(resourceName)}</h2>

      <Switch>
        <Route path={`${match.url}`} exact
               render={() => <List columns={columns}
                                   visibleColumn={visibleColumns}
                                   data={data}
                                   clearFilter={this.clearAll}
                                   filters={filters}
                                   handleChange={this.handleChange}
                                   columnChange={this.handleColumnChange}
                                   downloadToCSV={this.downloadToCSV}
                                   title={resourceName}
                                   size={'middle'}
                                   create={this.create}
                                   pagination={this.props.query.pagination}
                                   loading={loading}
                                   authUser={authUser}
               />
               }/>
        <Route path={`${match.url}/add`}
               render={(props) => <Create data={{}}
                                          filters={filters}
                                          modules={modules}
                                          title={'CREATE'}
                                          resource={resourceName}
                                          subDocumentFilters={this.props.subDocumentFilters}
                                          onChange={this.handleFormChange}
                                          onSubmit={this.createResource}
                                          searchData = {this.props.searchData}
                                          labourData = {this.props.labourData}
                                          sparesData =  {this.props.sparesData}
                                          fetchTpwNo = {this.fetchTpwNo}
                                          clearProps = {this.props.clearProps}
                                          storeTotalData = {this.storeTotalData}
                                          tpw = {this.props.tpw}
                                          loading={loading}
                                          {...props}
               />
               }/>
        <Route path={`${match.url}/edit/:id`}
               render={(props) => <Create data={edit}
                                          filters={filters}
                                          modules={modules}
                                          title={'EDIT'}
                                          resource={resourceName}
                                          fetch={fetchResource}
                                          clearProps = {this.props.clearProps}
                                          onChange={this.handleFormChange}
                                          loading={loading}
                                          disableAll = {true}
                                          disableMaster = {true}
                                          {...props}
               />
               }/>
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({auth, thirdPartyWorkQuotation, commonData}) => {
  return {
    authUser: auth.authUser,
    total: thirdPartyWorkQuotation.total,
    data: thirdPartyWorkQuotation.resources,
    resource: thirdPartyWorkQuotation.resource,
    edit: thirdPartyWorkQuotation.edit,
    query: thirdPartyWorkQuotation.query,
    labourData: thirdPartyWorkQuotation.labourTotal,
    sparesData: thirdPartyWorkQuotation.sparesTotal,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    tpw: thirdPartyWorkQuotation.tpwSno,
    searchData: commonData.relationshipSearch,
    subDocumentFilters: commonData.subDocumentFilters
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    clearProps,
    saveResourceQuery,
    fetchFilter,
    fetchTpwNo,
    fetchSubDocumentFilter,
    setValueForTotalSpare,
    setValueForTotalLabour,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(ThirdPartyWorkQuotation);
